module.exports = __webpack_public_path__ + "media/application/images/flags/united-kingdom-flag-square-icon-32-dfc5f2053c08ce5954800cf912442a26.png";